import { render, staticRenderFns } from "./CoverLetterView.vue?vue&type=template&id=00c80e61"
import script from "./CoverLetterView.vue?vue&type=script&lang=js"
export * from "./CoverLetterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports